import React from 'react';

interface MonitoringFiltersProps {
  selectedStatus: string;
  onStatusChange: (status: string) => void;
}

const MonitoringFilters: React.FC<MonitoringFiltersProps> = ({ selectedStatus, onStatusChange }) => {
  const statuses = [
    { value: 'all', label: 'All' },
    { value: 'running', label: 'Running' },
    { value: 'stopped', label: 'Stopped' },
    { value: 'warning', label: 'Warning' },
  ];

  return (
    <div className="flex items-center space-x-4">
      <span className="text-sm text-gray-600 dark:text-gray-400">Status:</span>
      <div className="flex space-x-2">
        {statuses.map((status) => (
          <button
            key={status.value}
            onClick={() => onStatusChange(status.value)}
            className={`px-3 py-1 text-sm rounded-md ${
              selectedStatus === status.value
                ? 'bg-blue-600 text-white'
                : 'bg-gray-100 text-gray-800 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600'
            }`}
          >
            {status.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MonitoringFilters;
